module.exports = __webpack_public_path__ + "static/akebia_hif_pathway-9eaf293e8f20154c5e09b673de61d891.mp4";